export const getFilteredValueByKey = function (refs, reference, key) {
    if (!refs || !reference) return null;

    var comp = refs[reference];
    if (!comp || !comp.$refs) return null;

    var grid = comp.$refs.transactionListGrid;
    if (!grid || !grid.$refs) return null;

    var panel = grid.$refs['gc-filter-panel'];
    if (!panel || !panel.$refs) return null;

    var form = panel.$refs['gc-form'];
    if (!form || !form.$refs) return null;

    var formComp = form.$refs['gc-form-comp'];
    if (!formComp || !formComp.instance) return null;

    var options = formComp.instance.option();
    if (key) {
        return options && options.formData ? options.formData[key] : null;
    }
    else { return options && options.formData ? options.formData : null; }
};